import React from 'react'
import { string, object, bool } from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import classnames from 'classnames'
import { sendClickEventToInsights } from '../../../utils/insights'
import { EMPTY_OBJECT } from '../../../utils/constants'
import { buttonMessages as messages } from '../messages'
import Button from './Button'
import Icon from '../icon/Icon'

/* eslint-disable-next-line max-len */
const SaveButton = ({ url, title, image, insights = EMPTY_OBJECT, gridView, isInit = true, id = '', customInitSelector = '', rest = EMPTY_OBJECT }) => {
  const intl = useIntl()
  const onClickTracked = e => {
    e.stopPropagation()
    if (window.AD && window.AD.isLoggedIn) {
      const isFrom = window.MyAD && window.MyAD.saveWithDropdown ? 'quick-save' : 'reg-save'
      const statusUpdate = e.currentTarget.dataset.status === 'update'
      const label = statusUpdate ? 'update' : 'save'
      const viewLabel = gridView ? 'grid' : 'list'
      sendClickEventToInsights(`${isFrom}_search_save-btn`, 'click', label, insights.value, viewLabel)
    }
  }
  const containerClass = gridView && '.gridview__item'
  const initClasses = classnames({ 'myarchdaily-multiple-fav': isInit })
  const withSaveDropdownClasses = classnames({ 'afd-btn--shorter': true })

  return (
    <div className='myad-save-button__box myad-save-button__box--absolute' onClick={e => e.stopPropagation()} id={id}>
      <Button
        mainClass='afd-btn'
        customClasses={`save-button afd-save-item ${initClasses} ${withSaveDropdownClasses} ${customInitSelector}`}
        href={url}
        data-container={containerClass}
        data-title={title}
        data-image={image}
        data-message={intl.formatMessage({ ...messages.save })}
        onClick={onClickTracked}
        linkButton
        data-dropdown='true'
        {...rest}
      >
        <Icon svg='folders' withoutHover />
        <span><FormattedMessage {...messages.save} /></span>
      </Button>
    </div>
  )
}

SaveButton.propTypes = {
  url: string.isRequired,
  title: string,
  image: string,
  insights: object.isRequired,
  gridView: bool,
  isInit: bool,
  customInitSelector: string,
  id: string,
  rest: object
}

export default SaveButton